import React  from 'react';
const FundingWallet = () => {
    return ( <>
    
    Wallet Funding
    
    </> );
}
 
export default FundingWallet;